import {
  CreateOrgAdminInput,
  CreateOrgAdminMutation,
  useCreateOrgAdminMutation,
  useOrgAdminsQuery,
  useOrgRolesQuery,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useOrgId } from '../useOrgId'

const removeRoleLabel = (currentRoleLabel: string, roleTitle: string) => {
  return currentRoleLabel
    .split(',')
    .filter((role) => role !== roleTitle)
    .join(',')
}
// current role lable might be a CSV of roles, so we need to merge them
const mergeRoleLabel = (currentRoleLabel: string, newRoleLabel: string) => {
  if (!currentRoleLabel) return newRoleLabel
  if (!newRoleLabel) return currentRoleLabel
  return Array.from(new Set([...currentRoleLabel.split(','), ...newRoleLabel.split(',')])).join(',')
}
export type UseCreateOrgAdminInput = Pick<
  CreateOrgAdminInput,
  'firstName' | 'lastName' | 'email' | 'roleLabel'
> & { remove?: boolean }
type UseCreateOrgAdminMutationOptions = UseGqlMutationCallbacks<
  CreateOrgAdminMutation,
  UseCreateOrgAdminInput
>

type UseCreateOrgAdminProps = {
  roleTitle?: string
}

export const useCreateOrgAdmin = (
  { roleTitle = '' }: UseCreateOrgAdminProps,
  options?: UseCreateOrgAdminMutationOptions
) => {
  const orgId = useOrgId()
  const { mutateAsync: createOrgAdmin } = useCreateOrgAdminMutation()
  const createAdmin = ({ remove, ...admin }: UseCreateOrgAdminInput) =>
    createOrgAdmin({ input: { ...admin, orgId } })
  const assignTitle = ({ remove, ...admin }: UseCreateOrgAdminInput) => {
    admin.roleLabel = remove
      ? removeRoleLabel(admin.roleLabel, roleTitle)
      : mergeRoleLabel(admin.roleLabel, roleTitle)
    return createAdmin(admin)
  }
  return useMutationWithInvalidation(assignTitle, options, [
    useOrgAdminsQuery.getKey({ orgId }),
    useOrgRolesQuery.getKey(),
  ])
}
